const ABSOLUTE_URL_REGEX = /^https?:\/\//i;

/**
 * Normalizza gli URL dei file restituiti dal backend.
 * Se l'URL è relativo (es. /uploads/..), viene prefissato con la base API.
 * Gli URL blob:, data: o già assoluti vengono restituiti tal quali.
 */
export function resolveAssetUrl(raw?: string | null): string | undefined {
    if (!raw) return undefined;
    const trimmed = raw.trim();
    if (trimmed === '') return undefined;

    if (ABSOLUTE_URL_REGEX.test(trimmed) || trimmed.startsWith('blob:') || trimmed.startsWith('data:')) {
        return trimmed;
    }

    const base = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080';
    if (trimmed.startsWith('/')) {
        return `${base}${trimmed}`;
    }
    return `${base}/${trimmed}`;
}
